<template>
  <fragment>
    <v-col cols="12" class="p-5">
      <div class="p-5" style="max-width: 97vw">
        <p class="text-justify" v-html="_messageInfoService.getExplanation('study')"></p>
      </div>
    </v-col>
    <v-col
      class="col-12 col-sm-6"
      style="padding-top: 0px"
      v-for="(prjItem, p) in itens"
      :key="'projeto-'+p"
    >
      <v-btn color="botao" block @click="selecionar(prjItem)">{{prjItem.name}}</v-btn>
    </v-col>
  </fragment>
</template>

<script>
import { mapMutations } from "vuex";

import InsurancePricingService from "../services/salesforce/InsurancePricingService";
import MessageInfoService from "../services/salesforce/MessageInfoService";
import store from "../store/store";
import { Fragment } from "vue-fragment";

export default {
  components: { Fragment },
  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      itens: [],
    };
  },
  beforeCreate() {
    this._insurancePricingService = new InsurancePricingService();
    this._messageInfoService = new MessageInfoService();
  },
  mounted() {
    this.getItens();
  },
  methods: {
    ...mapMutations(["toogleDialogLoading"]),
    selecionar(item) {
      this.model.selectProjeto = item;
      this.$emit("selecionar");
    },
    SemDados() {
      this.$emit("semdados");
    },
    naoDisponivel() {
      store.commit("showmsg", {
        text: this._messageInfoService.getExplanation("nao-disponivel"),
        type: "warning",
      });
    },
    async getItens() {
      if (!(this.model.loadquote && this.model.loadquote)) {
        this.toogleDialogLoading(true);
      }
      await this._insurancePricingService
        .getProjetos(this.model.user && this.model.user.userId, this.model.region.Id, this.model.persontype)
        .then((res) => {
          if (!res.data || res.data.length <= 0) {
            this.naoDisponivel();
            this.SemDados();
          } else {
            if (this.model.loadquote) {
              if (res.data.some((s) => s.Id == this.model.selectProjeto.Id)) {
                this.selecionar(
                  res.data.filter((f) => f.Id == this.model.selectProjeto.Id)[0]
                );
              } else {
                store.commit("showmsg", {
                  text: `Cotação origem realizada em ${this.model.quoteOriginDate} com projeto indisponível atualmente. Informe um novo projeto.`,
                  type: "warning",
                });

                this.model.loadquote = false;
                this.itens = res.data;
              }
            } else {
              this.itens = res.data;
            }
          }
        })
        .finally(() => {
          if (!(this.model.loadquote && this.model.loadquote)) {
            this.toogleDialogLoading(false);
          }
        });
    },
  },
};
</script>
